// extracted by mini-css-extract-plugin
export default {"modal":"Confirmation_modal__QTEHu","backdrop":"Confirmation_backdrop__E-S-o"};